import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from 'nuqs'

import {
  SelectableColumns,
  selectableColumns,
} from '../components/PositionsTable/ColumnsFilter/columns'

export const useSelectedColumnsQueryState = () => {
  const selectedColumnsParser = parseAsStringLiteral(
    selectableColumns.map((column) => column.id)
  )

  const queryStates = useQueryState(
    'selected-columns',
    parseAsArrayOf<SelectableColumns>(selectedColumnsParser).withDefault([
      'name',
      'company',
      'approval',
      'company-type',
      'created',
    ])
  )

  return queryStates
}
